import {fetchBody, URL_MODULE_GET_LIST, URL_MODULE_ADD, URL_MODULE_GET_DETAIL} from "../config"
import { toLogout, cleanFetch } from "./apiTools";
import { getToken } from "../component/Login/Auth";

export function api_getMoudleList ({success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({ token}), 
      url: URL_MODULE_GET_LIST, 
      success,
      failure
    })
  }
}

export function api_addModule ({mReqModule, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqModule, token}), 
      url: URL_MODULE_ADD, 
      success,
      failure
    })
  }
}

export function api_getModuleDetail ({mReqCategoryItem, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqCategoryItem, token}), 
      url: URL_MODULE_GET_DETAIL, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}